module.exports = __webpack_public_path__ + "r-branch.png?bd5c74ea6a43e6d4747ac4ee3c87568a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/r-branch.png
// module id = 64
// module chunks = 0